function initFaqList(accordionElement) {
    // ResizeObserver instance
    const resizeObserver = new ResizeObserver(entries => {
        if (!isAnimating) {
            entries.forEach(entry => {
                const inner = entry.target;
                const dd = inner.closest('dd');

                if (dd.previousElementSibling.classList.contains('js-expanded')) {
                    gsap.set(dd, { height: inner.clientHeight });
                }
            });
        }
    });

    let isAnimating = false;

    const toggleAccordion = (dt) => {
        const dd = dt.nextElementSibling;
        const inner = dd.querySelector('.inner');

        isAnimating = true;  // Set flag before animation starts

        if (!dt.classList.contains('js-expanded')) {
            dt.classList.add('js-expanded');
            gsap.set(dd, { height: "auto" });
            gsap.from(dd, .2, { height: 0, ease: Sine.easeInOut});
            gsap.from(inner, .2, { autoAlpha: 0, y: 10, onComplete: () => { isAnimating = false; } }, "<.1");

            // Attach observer
            resizeObserver.observe(inner);
        } else {
            dt.classList.remove('js-expanded');
            gsap.to(dd, .2, { height: 0, ease: Sine.easeInOut, onComplete: () => { isAnimating = false; } });

            // Detach observer
            resizeObserver.unobserve(inner);
        }
    };

    // Initial setup
    gsap.set(accordionElement.querySelectorAll('dd'), { height: 0 });

    // Event delegation
    accordionElement.addEventListener('click', (e) => {
        const dt = e.target.closest('dt');
        const closestAccordion = dt ? dt.closest('.accordion') : null;

        if (dt && closestAccordion === accordionElement) {
            toggleAccordion(dt);
        }
    });
}

// Initialize
document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("load", function () {
        document.querySelectorAll('.faqList').forEach(initFaqList);
    });
});
